import { render } from "./TabBar.vue?vue&type=template&id=0332d7ea&scoped=true"
import script from "./TabBar.vue?vue&type=script&lang=js"
export * from "./TabBar.vue?vue&type=script&lang=js"

import "./TabBar.vue?vue&type=style&index=0&id=0332d7ea&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_3ca827165d99699ca1e09c2bcd03c6d9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0332d7ea"]])

export default __exports__